import { render, staticRenderFns } from "./index-mobile.vue?vue&type=template&id=c29c5a28&scoped=true&lang=pug&"
import script from "./index-mobile.vue?vue&type=script&lang=js&"
export * from "./index-mobile.vue?vue&type=script&lang=js&"
import style0 from "./index-mobile.vue?vue&type=style&index=0&id=c29c5a28&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29c5a28",
  null
  
)

export default component.exports